import { connect } from "react-redux";

import {
	loadLogin,
	submitLogin,
	facebookLogin,
	submitReset,
	changeScreen,
	reactivateAccount,
	saveReactivateParams,
} from "ducks/login";
import {
	sendOTPCode,
	submitOTPCodeAndLogin,
	send2FaOTP,
	validate2FaOTP,
	resendOTPCode,
	resendOTPCodeSuccess,
	resendOTPCodeFailed,
} from "ducks/sms_login";
import { confirmToken } from "ducks/recaptcha";
import getApolloClient from "shared/util/getApolloClient";
import App from "apps/login/components/App";

const client = getApolloClient();

function mapStateToProps(state) {
	const { login, sms, smsLogin } = state;

	return {
		...login,
		sms,
		smsLogin,
	};
}

const mapDispatchToProps = {
	loadLogin,
	submitLogin,
	facebookLogin,
	submitReset,
	changeScreen,
	reactivateAccount,
	confirmRecaptchaToken: confirmToken,
	sendOTPCode: (dialingCode, phoneNumber) => sendOTPCode(client, dialingCode, phoneNumber),
	submitOTPCodeAndLogin: (code) => submitOTPCodeAndLogin(client, code),
	send2FaOTP: () => send2FaOTP(client),
	validate2FaOTP: (code) => validate2FaOTP(client, code),
	resendOTPCode: () => resendOTPCode(client),
	resendOTPCodeSuccess,
	resendOTPCodeFailed,
	saveReactivateParams,
};

export default connect(
	mapStateToProps,
	mapDispatchToProps,
)(App);



// WEBPACK FOOTER //
// ./src/apps/login/index.js